import { $t } from '../composables/i18n'

/**
 * @deprecated Use {@link Codebook} instead
 */
export abstract class TranslatableNameCodebook {
  protected constructor(public readonly name: string) {}

  /**
   * @deprecated In most usages this passes the name through translation twice. Rewrite this codebook to use {@link Codebook} instead.
   */
  public get translatedName(): string {
    return $t(this.name)
  }
}
